/// <reference types="@types/facebook-pixel" />
import type { Tracker } from '../../types';
import {
    awaitAdvertisingPixels,
    createMissingPixelWarning,
} from '../advertising-pixels';
import { getFacebookEvent } from './utils';

export function createFacebookTracker(): Tracker {
    const warnPixelMissing = createMissingPixelWarning('Meta');

    return {
        name: 'facebookTracker',
        async log(event, opts) {
            await awaitAdvertisingPixels();

            const facebookEventData = getFacebookEvent(event);
            if (!facebookEventData) return;

            const { eventName, type } = facebookEventData;

            if (typeof fbq === 'undefined') {
                warnPixelMissing(eventName);
                return;
            }

            console.log(
                '%cFacebookEvent: ' + eventName + ' (' + type + ')',
                'background: #222; color: #bada55',
            );

            const endpoint = type === 'standard' ? 'track' : 'trackCustom';

            // @todo map the customData object against valid Facebook parameters.
            if (opts.data) {
                fbq(endpoint, eventName, opts.data);
            } else {
                fbq(endpoint, eventName);
            }
        },
        release() {
            // do nothing
        },
    };
}
